const USER_TYPES = {
	INITIAL_STATE: 'USERS/INITIAL_STATE',
	GET_ALL: 'USER/GET_ALL',
	SET_ALL: 'USER/SET_ALL',
	GET_BY_INSTITUTION: 'USERS/GET_BY_INSTITUTION',
	GET_ALL_BY_INSTITUTION: 'USERS/GET_ALL_BY_INSTITUTION',
	SET_ALL_BY_INSTITUTION: 'USERS/SET_ALL_BY_INSTITUTION',
	GET_ONE: 'USERS/GET_ONE',
	SET_ONE: 'USERS/SET_ONE',
	CREATE: 'USERS/CREATE',
	UPDATE: 'USERS/UPDATE',
	REMOVE: 'USERS/REMOVE',
	SET: 'USERS/SET',
	BULK_UPLOAD: 'USERS/BULK_UPLOAD',
	DOWNLOAD_LAYOUT: 'USERS/DOWNLOAD_LAYOUT',
	SET_BULK_UPLOAD_SUMMARY: 'USERS/SET_BULK_UPLOAD_SUMMARY',
	GET_CERTIFICATES: 'USERS/GET_CERTIFICATES',
	SET_CERTIFICATES: 'USERS/SET_CERTIFICATES',
	DOWNLOAD_CERTIFICATES: 'USERS/DOWNLOAD_CERTIFICATES',
};

export default USER_TYPES;
